import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle} from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Select,
  Button,
  Space,
  message,
  InputNumber,
  Input
} from "antd";
import { HomeOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import dayjs from "dayjs";
import commonFn from "@/utils/commonFn";

const EmploymentTitleModal = forwardRef(({ submitInitFn }, ref) => {
    const [form] = Form.useForm();
    const [type, setType] = useState('add');
    const [oldState, setOldState] = useState({});
    const [modalName, setModalName] = useState('Payment Request');
    const [modalFlag, setModalFlag] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [roleList, setRoleList] = useState([]);
    
    
    useImperativeHandle(ref, () => ({
      openModal: ({type, modalName, oldState}) => {
        setType(type)
        setModalName(modalName)
        setOldState(oldState)
        setModalFlag(true)
      }
    }));

    const afterOpenChangeFn = (flag) => {
      if(flag){
        if(type !== 'add'){
          const temp = {
            ...oldState,
          }
          form.setFieldsValue(temp);
        } else {
        }
      }else{
        form.resetFields();
        setBtnLoading(false)
        setBtnDisabled(false)
      }
    }

    const testFn = async () => {
    }

    const submitAddOrEditFn = async(type) => {
      const flag = type === 'add'
      setBtnLoading(true)
      const response = await http.post(flag ? api.employmentTitleAdd : api.employmentTitleUpdate, {
        ...form.getFieldValue(),
      });
      if (response.code === "1") {
        message.success(`${flag ? 'New' : 'Edit'} successfully`);
        setModalFlag(false)
        submitInitFn();
      } else {
        commonFn.modalFailedFn(response)
      }
      setBtnLoading(false)
    }

    const submitFn = async() => {
      form.validateFields().then(value => {
        if(type === 'add' || type === 'edit'){
          submitAddOrEditFn(type)
        }
      }).catch(err =>{
        console.log(err,'===err');
      })
    }

    const getRoleList = async () => {
      const response = await http.get(api.getRolesList);
      setRoleList(response?.data || []);
    };  
  
    useEffect(() => {
      getRoleList();
    }, []);

  return (
    <Modal
      title={
        <div style={{ fontSize: "24px", fontWeight: "bold", color: "#3c8dbc" }}>
          <HomeOutlined style={{ marginRight: "8px" }} />
          {modalName}
          <div
            style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
          ></div>
        </div>
      }
      centered
      open={modalFlag}
      onCancel={() => setModalFlag(false)}
      footer={null}
      maskClosable={false}
      afterOpenChange={afterOpenChangeFn}
      width="30%"
    >
      <Form
        form={form}
        layout="horizontal"
        labelCol={{span: 8}}
        wrapperCol={{span: 16}}
        labelWrap={true}
        labelAlign="right"
        initialValues={{
          sortOrder: 0
        }}
        validateMessages={{
          required: "${label} is required!",
        }}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item
              name="titleName"
              label="Employment Title"
              rules={[{ required: true, message: 'Employment Title is required!' }]}
            >
              <Input
                placeholder="Please input Employment Title"
              />
            </Form.Item>

            <Form.Item
              name="titleCode"
              label="Code"
              rules={[{ required: true, message: 'Code is required!' }]}
            >
              <Input
                disabled={type !== 'add'}
                placeholder="Please input Code"
              />
            </Form.Item>

            <Form.Item
              name="roleIds"
              label="System Role"
              rules={[{ required: true, message: 'System Role is required!' }]}
            >
              <Select
                showSearch
                allowClear
                mode="multiple"
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.roleName ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                fieldNames={{
                  value: 'roleId',
                  label: 'roleName',
                }}
                options={roleList}
              />
            </Form.Item>

            <Form.Item
              name="sortOrder"
              label="Sort Order"
              rules={[{ required: true, message: 'Employment Title is required!' }]}
            >
              <InputNumber style={{ width: "100%" }} placeholder="Please input Sort Order" controls={false} />
            </Form.Item>

            <Form.Item
              name="status"
              label="Status"
              rules={[{ required: true, message: 'Status is required!' }]}
            >
              <Select
                showSearch
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[
                  {label: 'Active', value: 1},
                  {label: 'Inactive', value: 2},
                ]}
              />
            </Form.Item>

          </Col>
        </Row>
      </Form>
      <div style={{textAlign:'center'}}>
        <Space align="center">
          {/* <Button key="back" onClick={testFn}>
            TEST
          </Button> */}
          <Button key="back" onClick={() => setModalFlag(false)}>
            Cancel
          </Button>
          {
            type !== 'view' && (
              <Button type="primary" onClick={() => submitFn()} loading={btnLoading} disabled={btnDisabled}>
                Submit
              </Button>
            ) || null
          }
        </Space>
      </div>
    </Modal>
  );
});

export default EmploymentTitleModal;